import { Outlet } from "react-router-dom";

const UsersParentPage = () => {
    return <Outlet />
}
export default UsersParentPage;